import React, { useEffect, useState } from "react";
import {
    // Form,
    Button,
} from "semantic-ui-react";
import { Select, Input, Col, Row} from "antd";
import axios from 'axios'
const { Option, OptGroup } = Select;


const FiltroBancoJurado = ({ inputFilter, selectFilter, filterByMany, primerosDatosTabla }: any) => {
    const [filtroAvanzado, setFiltroAvanzado] = React.useState(false);

    const [areas, setAreas] = useState<any>([])
    const [categories, setCategories] = useState<any>([])
    const [wordToFilter, setWordToFilter] = useState<any>('')
    const [lineToFilter, setLineToFilter] = useState<any>('')
    const [categoryToFilter, setCategoryToFilter] = useState<any>('')
    const [statusToFilter, setStatusToFilter] = useState<any>('')


    const getAreas = async () => {
        const response: any = await axios.get(`${process.env.REACT_APP_SERVER_JURA2}areas`)
        setAreas(response.data.areas)
        console.log(response.data.areas);

    }


    const handleInputChange = (e: any) => {
        // console.log(e.target.value)
        setWordToFilter(e.target.value)
    }

    const handleLineChange = (value: any) => {
        setLineToFilter(value)

        let categoriesArray: any = []

        let filteredArea = areas.filter((area: any) => area.id_area === value)

        filteredArea[0].categorias_areas.forEach((category: any) => {
            categoriesArray.push(category)
        })
        console.log(categoriesArray);

        setCategories(categoriesArray)
    }

    const handleCategoryChange = (value: any) => {
        setCategoryToFilter(value)
    }

    const handleStatusChange = (value: any) => {
        //selectFilter(value)
        setStatusToFilter(value)
    }

    const handleFilterSubmit = async () => {
        const filterUrl = `${process.env.REACT_APP_SERVER_JURA2}juries/filter/many-filters/?code_word=${wordToFilter}&areaId=${lineToFilter}&categoryId=${categoryToFilter}&status=${statusToFilter}`

        filterByMany(filterUrl)
    }
    const handleReset = (e: any) => {
        // console.log(selectRef)
        setLineToFilter('')
        setCategoryToFilter('')
        setStatusToFilter(null)
        setWordToFilter('')
        // handleFilterSubmit()
        primerosDatosTabla();
        // selectRef.current.resetFields()
    }

    useEffect(() => {
        getAreas()
    }, [])

    return (
        <>
            <Row className="width-5" style={{ width: '350px' }}>
                <Col span={24}>
                    <span>Filtrar por palabra</span>
                </Col>
                <Col span={23}>
                    <Input type="text" value={wordToFilter} /* onKeyUp={inputFilter} */ onChange={(e) => handleInputChange(e)} />
                </Col>
            </Row>
            <Button
                style={{ marginTop: "auto" }}
                icon="filter"
                className="button-filtro-adminconvocatorias"
                onClick={() => setFiltroAvanzado(!filtroAvanzado)}
            />
            {filtroAvanzado ? (
                <div className="" style={{ marginTop: '20px', marginBottom: "10px", width: '100%' }}>
                    <Row className="width-100" gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'center', marginBottom: "10px", width: '100%' }}>
                        <Col span={8}>
                            <Row className="width-100" style={{ marginBottom: "10px", width: '100%' }}>
                                <Col span={30}>
                                    <span>Filtrar Expresión</span>
                                </Col>
                                <Col span={24}>
                                    <Select
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        onChange={(e) => handleLineChange(e)}
                                        value={lineToFilter}
                                    >
                                        {
                                            areas.map((area: any, index: number) => (
                                                <Option key={area.id_area} value={area.id_area} >{area.nombre_area}</Option>
                                            ))
                                        }
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={8}>
                            <Row className="width-100">
                                <Col span={30}>
                                    <span>Filtrar Categoría</span>
                                </Col>
                                <Col span={24}>
                                    <Select
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        onChange={(e) => handleCategoryChange(e)}
                                        value={categoryToFilter}
                                    >
                                        {
                                            categories.map((category: any, index: number) => (
                                                <Option key={category.id_categoria} value={category.id_categoria} >{category.nombre}</Option>
                                            ))
                                        }
                                    </Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={8}>
                            {/* <Form ref={selectRef}> */}
                                <Row className="width-100">
                                    <Col span={30}>
                                        <span>Filtrar Estado</span>
                                    </Col>
                                    <Col span={24}>
                                        <Select onChange={(e) => handleStatusChange(e)} value={ statusToFilter } style={{ width: "100%" }} placeholder="Seleccionar...">
                                            <Option value="1" >Sin verificar</Option>
                                            <Option value="3">No cumple</Option>
                                        </Select>
                                    </Col>
                                </Row>
                            {/* </Form> */}
                        </Col>

                    </Row>
                    <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Col >
                            <Button className="button-azul-ghost" type="reset" onClick={(e) => handleReset(e)} >
                                LIMPIAR FILTROS
                            </Button>
                            <Button className="button-azul-radius" onClick={handleFilterSubmit}>
                                BUSCAR
                            </Button>
                        </Col>
                    </Row>  </div>

            ) : null}

        </>
    )
}

export default FiltroBancoJurado